"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onSelectFocus = onSelectFocus;
exports.onSelectBlur = onSelectBlur;
function onSelectFocus(element) {
    var parent = element.closest('.md-select');
    parent.classList.remove("error");
    parent.classList.add("active");
    parent.classList.add("down");
}
function onSelectBlur(element) {
    var parent = element.closest('.md-select');
    parent.classList.remove("active");
    parent.classList.remove("down");
    if (element.value != "") {
        parent.classList.add("filled");
    } else {
        parent.classList.remove("filled");
        if (element.getAttribute("required") != null) {
            parent.classList.add("error");
        }
    }
}